import { useState} from "react";
import {useTranslation} from "react-i18next";
import {Paragraph} from "../../Elements/Paragraph";
import {I18NParagraph} from "../../Elements/I18NParagraph";
import type { IntervalInputProps } from "./IntervalInput.interface";

type ErrorComponentProps = {i18n:string, fieldId?:string};

function ErrorComponent({i18n, fieldId}:ErrorComponentProps) {

  return <div className={"textInput-notifications"}>
          <div id={fieldId ? fieldId + "-error" : undefined} className="textInput_message">
            <div className="textInput_corner error"/>
            <I18NParagraph
                className="textInput_text error"
                i18n={i18n}
            />
          </div>

    </div>;
}

export function IntervalInput({id, placeholderText,onChange,name, labelText, defaultValue}:IntervalInputProps) {

  const {t} = useTranslation();
  const [selected, setSelected] = useState<number>(defaultValue || 0);

  function formatSeconds (sec:number)  {
    if (!sec || isNaN(sec)) return t("timechooser.invalidInput");

    let total = sec;

    const years = Math.floor(total / (60 * 60 * 24 * 365));
    total %= 60 * 60 * 24 * 365;

    const months = Math.floor(total / (60 * 60 * 24 * 30));
    total %= 60 * 60 * 24 * 30;

    const weeks = Math.floor(total / (60 * 60 * 24 * 7));
    total %= 60 * 60 * 24 * 7;

    const days = Math.floor(total / (60 * 60 * 24));
    total %= 60 * 60 * 24;

    const hours = Math.floor(total / (60 * 60));
    total %= 60 * 60;

    const minutes = Math.floor(total / 60);
    const secs = total % 60;

    const parts = [];
    if (years > 0) parts.push(t("timechooser.year", {count: years}));
    if (months > 0) parts.push(t("timechooser.month", {count: months}));
    if (weeks > 0) parts.push(t("timechooser.week", {count: weeks}));
    if (days > 0) parts.push(t("timechooser.day", {count: days}));
    if (hours > 0) parts.push(t("timechooser.hour", {count: hours}));
    if (minutes > 0) parts.push(t("timechooser.minute", {count: minutes}));
    if (secs > 0 || parts.length === 0) parts.push(t("timechooser.second", {count: secs}));
    return parts.join(", ");
  }

  return (<>
    <div className="textInput">
      <label className="textInput_label">{labelText}</label>
      <div className={"input-password-wrapper"}>
        <input
            type="number"
            value={selected}
            id={id}
            name={name}
            onChange={(e) => {
              const val : number = parseInt(e.target.value, 10);
              if (selected !== val) {
                setSelected(val);
                if (onChange) {
                  onChange(val);
                }
              }
            }}
            className="textInput_input"
            placeholder={placeholderText}
        />
      </div>
      {selected !== undefined && !isNaN(selected) && selected !== 0 && <Paragraph className={"note"} text={formatSeconds(selected)} />}
      {selected === 0 && <ErrorComponent i18n={"timechooser.invalidInputNull"} />}
      {(selected === undefined || isNaN(selected)) && <ErrorComponent i18n={"timechooser.invalidInput"} />}
    </div>
  </>);
}